export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/'
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const MODAL_CLOSE_SEC = 2.5;
export const KEY = 'a6d4a036-e66d-4c45-9ebf-913db31001aa';
